import type { ForqSupabaseClient } from './client';
import type { ExportLogEntry, ExportLogGateway, RecordExportInput } from '@forq/finance-data';
import { SupabaseOperationError } from './errors';

function messageOf(error: { readonly message: string } | null): string {
  return error?.message ?? 'Unknown Supabase error.';
}

/**
 * DATEV-Export-Protokoll gegen Supabase.
 *
 * Das Protokoll waechst nur (GoBD-Nachweis): dieser Adapter kennt bewusst NUR listExports und
 * recordExport -- kein Loeschen, kein Aendern. Die RPCs geben den Eintrag als jsonb GENAU in der Form
 * von ExportLogEntry zurueck (camelCase); ein Test in exportLog.test.ts sichert die Gestalt.
 */
export class SupabaseExportLogGateway implements ExportLogGateway {
  constructor(private readonly client: ForqSupabaseClient) {}

  private async rpc(functionName: string, args: Record<string, unknown>): Promise<unknown> {
    const { data, error } = await this.client.rpc(functionName, args);
    if (error) throw new SupabaseOperationError(`finance.${functionName}`, messageOf(error));
    return data;
  }

  async listExports(tenantId: string): Promise<readonly ExportLogEntry[]> {
    const data = await this.rpc('finance_export_log_list', { p_tenant_id: tenantId });
    return (data ?? []) as readonly ExportLogEntry[];
  }

  async recordExport(input: RecordExportInput): Promise<ExportLogEntry> {
    const { tenantId, period, ...rest } = input;
    // Der Zeitraum wird flach in from/to gelegt (die RPC erwartet '' fuer einen unbegrenzten Rand).
    return this.rpc('finance_export_log_record', {
      p_tenant_id: tenantId,
      p_payload: { ...rest, from: period.from, to: period.to },
    }) as Promise<ExportLogEntry>;
  }
}
